import React from 'react'
import { Circle } from 'lucide-react'
import { tokens } from '../../../assets/tokens'

const icon = props => <Circle size={12} color={tokens.color.text.tertiary} fill={tokens.color.text.tertiary} {...props} />

export default icon
